import { makeStyles, shorthands } from '@fluentui/react-components';

export const useStyles = makeStyles({
  outcomePage: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    width: '100%',
    backgroundColor: '#fafafa',
    ...shorthands.padding('24px'),
  },
  outcomeCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: 'min(384px, 100%)',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    ...shorthands.border('1px', 'solid', 'rgba(164, 171, 196, 0.4)'),
    borderRadius: '8px',
    boxShadow: '0 1px 4px rgba(4, 13, 38, 0.04), 0 32px 48px rgba(4, 13, 38, 0.04)',
  },
  failureCard: {
    minHeight: '324px',
  },
  failureIcon: {
    width: '36px',
    height: '36px',
    marginTop: '37px',
    color: '#db4431',
  },
  failureTitle: {
    marginTop: '39px',
    fontFamily: '"Proxima Nova", Arial, sans-serif',
    fontSize: '16px',
    fontWeight: '500',
    lineHeight: '18px',
    color: '#040d26',
  },
  failureDescription: {
    width: '334px',
    marginTop: '30px',
    fontFamily: '"Proxima Nova", Arial, sans-serif',
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '21px',
    color: '#283044',
  },
  successCard: {
    minHeight: '313px',
  },
  successIcon: {
    width: '47px',
    height: '47px',
    marginTop: '30px',
  },
  successTitle: {
    marginTop: '19px',
    fontFamily: '"Proxima Nova", Arial, sans-serif',
    fontSize: '16px',
    fontWeight: '500',
    lineHeight: '18px',
    color: '#040d26',
  },
  successDescription: {
    width: '334px',
    marginTop: '31px',
    fontFamily: '"Proxima Nova", Arial, sans-serif',
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '21px',
    color: '#283044',
  },
  successButton: {
    minWidth: '48px',
    minHeight: '24px',
    marginTop: '39px',
    ...shorthands.padding('1px', '9px'),
    fontFamily: '"Proxima Nova", Arial, sans-serif',
    backgroundColor: '#1a2ef9',
    ...shorthands.border('1px', 'solid', 'transparent'),
    borderRadius: '4px',
    fontSize: '12px',
    fontWeight: '500',
    lineHeight: '14px',
  },
});
